<gk-skip-links
  [currentSkipLinksConfiguration]="currentSkipLinksConfiguration"
></gk-skip-links>
